import {assert} from 'assert-ts';
import type {Prize} from 'api/types';
import type {EditorMode} from 'editors/types';
import {useLocalization} from 'localization';

export const usePrizeTitle = (
  mode: EditorMode,
  prize: Prize | undefined,
): string => {
  const {t} = useLocalization();
  if (mode === 'register') {
    return t(`page.prize.add.title`);
  }

  const p = assert(prize, 'usePrizeTitle: prize is required when mode is edit');
  return p.name ?? '';
};
